import type { ConciseWorkspace } from '@festina/configuration-general-types/configuration'
import type { WorkspaceKey } from '@festina-life/api'
import { assertNotEmpty, type ConfigurableServer } from '@festina-life/core'

export const conciseWorkspaceToWorkspaceKey = ({
  workspace,
  server,
}: {
  workspace: ConciseWorkspace
  server: ConfigurableServer
}): WorkspaceKey => {
  assertNotEmpty(workspace.baseBranchName)
  assertNotEmpty(workspace.name)

  return {
    branchKey: { name: workspace.baseBranchName, server },
    name: workspace.name,
  }
}
